import React, { createContext, useContext } from 'react';
import { CompanyInfo } from '../types';
import { useAuthWorkspace } from './AuthWorkspaceContext';

interface CompanyContextType {
  company: CompanyInfo | null;
  userCompanies: CompanyInfo[];
  isBlocked: boolean;
  switchCompany: (targetCompanyId: string) => Promise<void>;
  updateCompanyDetails: (data: Partial<CompanyInfo>) => Promise<void>;
}

const CompanyContext = createContext<CompanyContextType | undefined>(undefined);

export function CompanyProvider({ children }: { children: React.ReactNode }) {
  const {
    companyInfo,
    userCompanies,
    isBlocked,
    handleSwitchCompany,
    handleUpdateCompany
  } = useAuthWorkspace();

  return (
    <CompanyContext.Provider
      value={{
        company: companyInfo,
        userCompanies,
        isBlocked,
        switchCompany: handleSwitchCompany,
        updateCompanyDetails: handleUpdateCompany
      }}
    >
      {children}
    </CompanyContext.Provider>
  );
}

export function useCompany() {
  const context = useContext(CompanyContext);
  if (!context) {
    throw new Error('useCompany must be used within a CompanyProvider');
  }
  return context;
}
